import { type Campanha } from '@/service/api'
import { useOutletContext } from 'react-router-dom'

export function useCamapanhaOutletContext() {
    return useOutletContext<{ data: Campanha[] }>()
}
